export default __webpack_public_path__ + "static/media/BancoLogoGrey.70d80c46.png";